import axios from 'axios';
import auth from '@/services/authSvc';

export default {
  loginUserWithClinicalPortalToken
};

export const UninterceptedHTTP = axios.create({
  baseURL: auth.getApiUrl(),
  headers: { Pragma: 'no-cache' }
});

function loginUserWithClinicalPortalToken(liveonAuthView) {
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';

  return UninterceptedHTTP.post(`/public/v3/auth/clinical?tz=${userTimeZone}`, liveonAuthView);
}
